export interface RefundItemsFormDataBuilderInterface {
  bookingNo: string;
  email: string;
}
